import { API } from "./api";

function getSessionId() {
  try {
    let sid = localStorage.getItem("ms_sid");
    if (!sid) {
      sid = crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2);
      localStorage.setItem("ms_sid", sid);
    }
    return sid;
  } catch {
    return "anon-" + Math.random().toString(36).slice(2);
  }
}

function getDevice() {
  if (typeof window === "undefined") return "unknown";
  const ua = navigator.userAgent || "";
  return /Mobi|Android|iPhone|iPad|iPod/i.test(ua) ? "mobile" : "desktop";
}

export async function track(event) {
  try {
    await fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event,
        session_id: getSessionId(),
        device: getDevice(),
        path: typeof window !== "undefined" ? window.location.pathname : "/",
      }),
      keepalive: true,
    });
  } catch {
    /* swallow — analytics must never break UX */
  }
}
